module.exports = __webpack_public_path__ + "img/architecture-style-icon_1.137c563c.png";